import { render } from "./DeadProposalReport.vue?vue&type=template&id=4dc1e2bf&scoped=true"
import script from "./DeadProposalReport.vue?vue&type=script&lang=js"
export * from "./DeadProposalReport.vue?vue&type=script&lang=js"

import "./DeadProposalReport.vue?vue&type=style&index=0&id=4dc1e2bf&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc1e2bf"]])

export default __exports__